<div [formGroup]="form()">
  <ct-lib-info-banner>
    <p>{{ 'jobboard.platform.settings.visibility.info' | transloco }}</p>
  </ct-lib-info-banner>
  <ct-lib-segmented-control
    [items]="modeItems"
    [selectedValue]="selectedMode()"
    (valueChange)="onModeChange($event)"
  ></ct-lib-segmented-control>
  @if (paused()) {
    <div class="pause-details">
      <div class="form-group form-floating">
        <ng-select
          class="form-control"
          formControlName="pauseDuration"
          [clearable]="false"
          [searchable]="false"
          appendTo="body"
          [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
          id="settingsPauseDuration"
          (change)="onDurationChange()"
        >
          @for (duration of pauseDurations; track duration) {
            <ng-option [value]="duration">{{ durationKey(duration) | transloco }}</ng-option>
          }
        </ng-select>
        <label for="settingsPauseDuration">{{
          'jobboard.platform.settings.visibility.duration-label' | transloco
        }}</label>
      </div>
      @if (pausedUntil(); as until) {
        <p class="pause-until">
          {{
            'jobboard.platform.settings.visibility.paused-until'
              | transloco: { date: (until | date: 'dd.MM.yyyy') }
          }}
        </p>
      } @else {
        <p class="pause-until">
          {{ 'jobboard.platform.settings.visibility.paused-indefinitely' | transloco }}
        </p>
      }
    </div>
  }
</div>
